module.exports = __webpack_public_path__ + "static/media/i4c-strategies.89153d19.svg";